import * as React from "react";

import { Doc } from "affinityUI/structures/doc";

import resultsCardLabelled1 from "./assets/Results Card Labelled 1.png";
import resultsCardLabelled2 from "./assets/Results Card Labelled 2.png";
export const ResultsCardSection: React.FC = () => {
  return (
    <Doc.Section title="Results Card">
      <p>
        A patient&apos;s latest result will be displayed in card format on the home screen. A card will show three
        patient identifiers; date of birth, hospital number and patient ID. You can also select a result by pressing the
        blue button. Selecting a result will give access to patients&apos; history and full details. The patient’s
        result history is presented on the Review patient page.
      </p>

      <ul>
        <li>
          <strong>Patient identifiers (A)</strong>
        </li>
        <li>
          <strong>Date of test (B)</strong>
        </li>
        <li>
          <strong>Parameter (C)</strong>
        </li>
        <li>
          <strong>Normal ranges (D)</strong>
        </li>
        <li>
          <strong>Select result (E)</strong>
        </li>
      </ul>
      <Doc.Illustration src={resultsCardLabelled1} />
      <Doc.Illustration src={resultsCardLabelled2} label="Results card labelled" />
    </Doc.Section>
  );
};
